export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/banner-13.jpg'),
        title: '企业应用',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: '​​任何组织的关键组成部分',
      description: `<p style="font-size:1.05rem">随着组织的发展，您会发现现成的软件不再满足您企业环境的需求。公司和大型企业拥有自己独特的业务流程，数据结构和工作流程，这是企业应用程序的用武之地：它是专为满足特定组织需求而设计的大型软件平台。企业应用程序（也称为企业应用程序软件（EAS））是任何组织的关键组成部分，包括（但不限于）企业，教育机构，银行甚至政府。企业应用程序将增强组织的工作流程和生产力.MaesInfo的软件开发服务包括根据您组织的需求定制的企业应用程序开发。我们的软件开发团队在为全球客户构建软件应用程序方面拥有丰富的经验。我们开发的一些企业应用程序包括（但不限于）：</p>
      <p>支付处理系统、
自动计费系统、
CRM（客户关系管理）、
ERP（企业资源规划）http://maesinfo.com/solutions/erp.html、
BCP（业务连续性计划）、
RFID（射频识别）http://maesinfo.com/solutions/rfid.html、
IT服务管理和许多其他
</p>`
    },
    {
      title: '​​与MaesInfo合作的好处:',
      description: `<span class='img' style="background:url(`+require('../../../assets/images/services/pic-13.jpg')+`)"></span>
      <span class="list">
      <i></i>​​我们的顾问团队可以为应用技术和服务提供建议
提供商在快速变化的地方和如何发展业务的地方和方式
全球市场<br/>
 <i></i>帮助您的企业应用程序将整个基础架构迁移到
云，随着越来越多的企业转向提供On-Demand类型
服务<br/>
 <i></i>我们的团队能够为您构建可扩展的企业应用程序，使其成为可能
你需要它复杂<br/>
 <i></i>MaesInfo将整合您所有组织的业务流程（例如
因此，会计，销售，人力资源和制造）成为企业应用程序
通过单一的软件架构让您控制所有这些<br/>
 <i></i>我们可以将供应商，客户和合作伙伴集成到您的企业应用程<br/>
 <i></i>我们不仅提供具有成本效益的解决方案，还提供节省时间的解决方案<br/>
 <i></i>我们可以在各种网络上部署您的企业应用程序（Internet，
内联网和企业网络），采取适当的安全措施
      </span>`
    }
  ]
}
